import React, { useEffect, useState } from 'react';
import { TouchableOpacity, View, Text } from 'react-native'
import { LinearGradient } from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';

const AnnouncementBar = () => {
  const [reportName, setReportName] = useState('');
  const [error, setError] = useState(null);
  let navigation;
  try {
    navigation = useNavigation();
  } catch (e) {
    navigation = null;
  }

  useEffect(() => {
    const loadReportName = async () => {
      try {
        const reportData = await AsyncStorage.getItem('current_report');
        if (reportData) {
          try {
            const report = JSON.parse(reportData);
            setReportName(report.name || '');
            setError(null);
          } catch (parseError) {
            console.error('Error parsing report data:', parseError);
            setReportName(reportData);
            setError(null);
          }
        } else {
          setReportName('');
          setError(null);
        }
      } catch (error) {
        console.error('Error loading current_report from storage:', error);
        setError(error.message);
        setReportName('');
      }
    };

    loadReportName();
    const intervalId = setInterval(loadReportName, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleDone = async () => {
    try {
      const currentReportId = await AsyncStorage.getItem('current_report_id');
      const currentMode = await AsyncStorage.getItem('current_report_mode');

      if (currentReportId) {
        navigation.navigate('ViewInventoryReport', {
          id: currentReportId,
          view: 'show',
          from: 'done_button',
          mode: currentMode
        });
      } else {
        navigation.navigate('ViewInventoryReport');
      }
    } catch (error) {
      navigation.navigate('ViewInventoryReport');
    }
  };

  return (
    <View style={{
      backgroundColor: '#0F0F0F',
      height: 34,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 15,
      paddingRight: 15,
      }}>
      <Text style={{ color: '#979797', fontSize: 16, fontFamily: fontFamily.font300 }}>
      {reportName}
      </Text>

      <TouchableOpacity onPress={handleDone}>
        <LinearGradient
          colors={['#7BFAC3', '#1CBB77']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={{
            width: 70,
            height: 27,
            paddingHorizontal: 14,
            paddingVertical: 3,
            borderRadius: 15,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text style={{ color: '#000000', fontSize: 16, fontFamily: fontFamily.font300 }}>
            Done
          </Text>
        </LinearGradient>
      </TouchableOpacity>
    </View>
  )
}

export default AnnouncementBar;
